import {AudioListener} from "three";

export const audioListener = new AudioListener();